import {
  CLEAR_FLAGS_PARAMETROS_EMBEDDED_BI,
  SET_PARAMETROS_EMBEDDED_BI_INIT,
  SET_PARAMETROS_EMBEDDED_BI_SUCCESS,
  ERROR_PARAMETROS_EMBEDDED_BI_MSG,
  SET_ARQUITETURA_PBI_ATIVA_INIT,
  SET_ARQUITETURA_PBI_ATIVA_SUCCESS,
  ERROR_ARQUITETURA_PBI_ATIVA_MSG,
  CRIAR_WORKSPACE_INIT,
  ATUALIZAR_WORKSPACE_INIT,
  CRIAR_NOVA_VERSAO_WORKSPACE_INIT
} from '../../actionTypes';

export const clearFlagsParametrosEmbeddedBi = () => ({
  type: CLEAR_FLAGS_PARAMETROS_EMBEDDED_BI
});

export const setParametrosEmbeddedBiInit = (data) => ({
  type: SET_PARAMETROS_EMBEDDED_BI_INIT,
  payload: data
});

export const setParametrosEmbeddedBiSuccess = ({ msg, chave }) => {
  return {
    type: SET_PARAMETROS_EMBEDDED_BI_SUCCESS,
    payload: { msg, chave }
  };
};
export const errorParametrosEmbeddedBiMsg = (data) => ({
  type: ERROR_PARAMETROS_EMBEDDED_BI_MSG,
  payload: data
});

export const setArquiteturaPbiAtivaInit = (data) => ({
  type: SET_ARQUITETURA_PBI_ATIVA_INIT,
  payload: data
});

export const criarWorkSpaceInit = (data) => ({
  type: CRIAR_WORKSPACE_INIT,
  payload: data
});

export const atualizarWorkSpaceInit = (data) => ({
  type: ATUALIZAR_WORKSPACE_INIT,
  payload: data
});

export const criarNovaVersaoWorkSpaceInit = (data) => ({
  type: CRIAR_NOVA_VERSAO_WORKSPACE_INIT,
  payload: data
});

export const setArquiteturaPbiAtivaSuccess = (data) => ({
  type: SET_ARQUITETURA_PBI_ATIVA_SUCCESS,
  payload: data
});

export const errorArquiteturaPbiAtivaMsg = (data) => ({
  type: ERROR_ARQUITETURA_PBI_ATIVA_MSG,
  payload: data
});
